<template>
  <div class="audit">
    <div class="up-fun">
      <div>
        <span style="font-size: 30px;font-weight: bold">二维码申请与生成</span>
      </div>
      <div class="cre-btn">
        <!--<el-button @click="dialogVisible = true" icon="el-icon-edit-outline" class="qrBtn" type="primary text">
          生成二维码
        </el-button>-->
        <el-button type="primary" @click="dialogVisible=true">生成二维码</el-button>
      </div>
      <div class="search-fun">
        <el-input class="sty-margin search-input" v-model="name" clearable placeholder="姓名"
                  @clear="initselectAll"></el-input>
        <el-button class="sty-margin" @click="selectAllByCondition('name')">搜索</el-button>

        <el-input class="sty-margin search-input" v-model="phone" clearable placeholder="电话"
                  @clear="initselectAll"></el-input>
        <el-button class="sty-margin" @click="selectAllByCondition('phone')">搜索</el-button>

        <el-input class="sty-margin search-input" v-model="address" clearable placeholder="地址"
                  @clear="initselectAll"></el-input>
        <el-button class="sty-margin" @click="selectAllByCondition('address')">搜索</el-button>

        <el-select class="sty-margin" v-model="status" clearable placeholder="请选择" @change="changeStatus"
                   @clear="initselectAll">
          <el-option
            v-for="item in statusData"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div>
      <el-table :data="tableData" v-loading="loadding" @selection-change="changeSelections">
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column label="id" prop="id" align="center"></el-table-column>
        <el-table-column label="二维码编号" prop="qrContentParam" align="center"></el-table-column>
        <el-table-column label="申请人" align="center">
          <template slot-scope="scope_owner">
            <span v-if="scope_owner.row.owner==1">xiannao</span>
            <span v-else>{{scope_owner.row.owner}}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" align="center">
          <template slot-scope="scope_proposer">
            <span>{{scope_proposer.row.proposer}}</span>
          </template>
        </el-table-column>
        <el-table-column label="电话" prop="shopPhone" align="center">
          <template slot-scope="scope_shopPhone">
            <span>{{scope_shopPhone.row.shopPhone}}</span>
          </template>
        </el-table-column>
        <el-table-column label="地址" prop="" align="center">
          <template slot-scope="scope_add">
            <span>{{scope_add.row.district}}{{scope_add.row.street}}{{scope_add.row.shopAddress}}</span>
          </template>
        </el-table-column>
        <el-table-column label="激活时间" prop="updateTime" align="center">
          <template slot-scope="scope_updateTime">
            <span>{{formatTime(scope_updateTime.row.updateTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请方式" prop="proposalForm" align="center">
          <template slot-scope="scope_proposalForm">
            <span v-if="scope_proposalForm.row.proposalForm==1">邮寄</span>
            <span v-else-if="scope_proposalForm.row.proposalForm==2">打印</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="status" align="center">
          <template slot-scope="scope_status">
            <el-button v-if="scope_status.row.status=='WATTING'">待审核</el-button>
            <a v-else-if="scope_status.row.status=='ACTIVATED'" @click="addActives(scope_status.row)">
              <el-button>已激活</el-button>
            </a>
            <el-button v-else-if="scope_status.row.status=='TO_BE_MAILED'" class="to-be-mailed">已激活未邮寄</el-button>
            <el-button v-else>-</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fun-btns">
      <el-button @click="changeStatusForPass">审核通过</el-button>
      <el-button @click="changeStatusForMail">确认邮寄</el-button>
      <el-button @click="delApplyFor">删除</el-button>
      <el-button @click="downLoadPicture">下载</el-button>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <!--生成二维码表单dialog-->
    <el-dialog title="生成二维码" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form">
        <el-form-item align="left" style="margin-left: 8%">
          <el-switch
            @change="showStatus"
            v-model="switchValue"
            active-text="多个"
            inactive-text="单个">
          </el-switch>
        </el-form-item>
        <el-form-item label="二维码个数" label-width="120px" align="left" v-show="isShow">
          <el-input v-model="num" autocomplete="off" style="width: 50%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="createQrCode">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "audit",
    data() {
      return {
        name: '',
        phone: '',
        address: '',
        currentPage: 1,
        pageSize: 10,
        total: 0,
        tableData: null,
        loadding: false,
        statusData: [
          {
            label: '待审核',
            value: 'WATTING'
          },
          {
            label: '已激活待邮寄',
            value: 'TO_BE_MAILED'
          },
          {
            label: '已激活',
            value: 'ACTIVATED'
          }
        ],
        status: '',
        selectRows: null,
        form: {},
        switchValue: false,
        num: '',
        isShow: false,
        dialogVisible: false,
      }
    },
    methods: {
      selectAll() {
        this.$http.post(this, '/qrcode/getProposalInfo', {
          name: this.name,
          phone: this.phone,
          address: this.address,
          status: this.status,
          pageSize: this.pageSize,
          currentPage: this.currentPage - 1
        }).then(res => {
          this.total = res.data.count
          this.tableData = res.data.data
        })
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.selectAll()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.selectAll()
      },
      formatTime(updateTime) {
        if (!updateTime) {
          return '';
        }
        return new Date(updateTime).format("yyyy/MM/dd hh:mm");
      },
      changeStatus() {
        this.pageSize = 10
        this.currentPage = 1
        this.name = ''
        this.phone = ''
        this.address = ''
        this.selectAll()
      },
      selectAllByCondition(val) {
        this.pageSize = 10
        this.currentPage = 1
        if (val == 'name') {
          this.phone = ''
          this.address = ''
          this.status = ''
        } else if (val == 'phone') {
          this.name = ''
          this.address = ''
          this.status = ''
        } else if (val == 'address') {
          this.name = ''
          this.phone = ''
          this.status = ''
        }
        this.selectAll()
      },
      changeSelections(val) {
        this.selectRows = val
      },
      changeStatusForPass() {
        let list = []
        if (this.selectRows == null) {
          return
        }
        this.selectRows.forEach(item => {
          let qrInfo = {}
          if (item.status == 'WATTING') {
            if (item.proposalForm == 1) {
              qrInfo.id = item.id
              qrInfo.status = 'TO_BE_MAILED'
              list.push(qrInfo)
            } else if (item.proposalForm == 2) {
              qrInfo.id = item.id
              qrInfo.status = 'ACTIVATED'
              list.push(qrInfo)
            }
          } else {
            return
          }
        })
        if (list.length > 0) {
          this.$http.post(this, '/qrcode/auditPass', {}, list).then(res => {
            if (res.code == 200) {
              this.selectAll()
              this.$message({
                message: '审核成功！',
                type: 'success'
              });
            } else {
              this.$message({
                message: '审核失败！',
                type: 'error'
              });
            }
          })
        } else {
          return
        }
      },
      changeStatusForMail() {
        let idList = []
        if (this.selectRows == null) {
          return
        }
        this.selectRows.forEach(item => {
          if (item.status == 'TO_BE_MAILED') {
            idList.push(item.id)
          } else {
            return
          }
        })
        if (idList.length > 0) {
          this.$http.post(this, '/qrcode/confirmMail', {}, idList).then(res => {
            if (res.code == 200) {
              this.$message({
                message: '状态更新成功!',
                type: "success"
              })
              this.selectAll()
            } else {
              this.$message({
                message: '状态更新失败!',
                type: "error"
              })
            }
          })
        } else {
          return
        }
      },
      delApplyFor() {
        let ids = []
        if (this.selectRows == null) {
          return
        }
        this.selectRows.forEach(item => {
          if (item.status != null) {
            ids.push(item.id)
          }
        })
        if (ids.length > 0) {
          this.$http.post(this, '/qrcode/delApply', {}, ids).then(res => {
            if (res.code == 200) {
              this.$message({
                message: '删除成功!',
                type: "success"
              })
            } else {
              this.$message({
                message: '删除失败!',
                type: "error"
              })
            }
          })
        }
      },
      downLoadPicture() {
        if (this.selectRows == null || this.selectRows.length == 0) {
          return
        } else {
          const loading = this.$loading({
            text: '码农哥哥正在努力下崽中......',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          this.selectRows.forEach(item => {
            this.load(item.picAddress, item.qrContentParam)
          })
          loading.close();
          this.$message.success("图片已下载成功,请查收~");
        }
      },
      load(url, name) {
        var request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.responseType = 'blob';
        request.onload = function (e) {
          var url = window.URL.createObjectURL(request.response)
          var a = document.createElement('a');
          a.href = url
          a.download = name + ".png"; //下载后的文件名
          a.click()
        }
        request.send();
      },
      addActives(row) {
        console.log(row);
        let query = {
          condition: 3,
          param: row.qrContentParam
        }
        this.$router.push({path: '/audit/addAactive', query: query});
      },
      initselectAll() {
        this.pageSize = 10
        this.currentPage = 1
        this.selectAll()
      },
      showStatus() {
        this.isShow = !this.isShow
      },
      async createQrCode() {
        const loading = this.$loading({
          text: '码农哥哥正在努力加载中......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.dialogVisible = false
        if (this.num === '' || this.num === null) {
          this.num = 1
        }
        let params = {
          'num': this.num
        }
        this.$http.get2(this, '/qrcode/create', params).then(response => {
          let blob = new Blob([response], {type: 'application/zip'})
          let url = window.URL.createObjectURL(blob)
          const link = document.createElement('a') // 创建a标签
          link.href = url
          link.download = '二维码' // 重命名文件
          link.click()
          URL.revokeObjectURL(url) // 释放内存
          loading.close()
          this.selectAll()
        }).catch(error => {
          loading.close()
          this.$message.error("下载失败了~   赶紧去找码农！！！")
          console.log(error)
        })
        this.num = ''
      },
    },
    created() {
      this.selectAll()
    }
  }
</script>

<style scoped>
  .up-fun {

  }

  .cre-btn {
    margin-top: 1%;
  }

  .search-fun {
    display: flex;
  }

  .sty-margin {
    margin-top: 1%;
    margin-right: 1%;
  }

  .search-input {
    width: 300px;
  }

  .fun-btns {
    margin: 1% 0px;
  }

  .to-be-mailed {
    padding: 12px 5px;
    font-size: 10px;
  }
</style>
